// @owners { team: patients }
import { type AltoIconName, SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, Icon, LgPadding, ListBase, PresentationListItem, SmSpacing } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { AUTO_REFILL_INFO_ACTION_SHEET } from '~shared/features/auto-refill/constants';
export const AutoRefillInfoActionSheet = () => {
  const autoRefillSteps = AUTO_REFILL_INFO_ACTION_SHEET.map((step) => {
    return {
      key: step.key,
      component: (
        <PresentationListItem
          LeftContent={<Icon name={step.icon as AltoIconName} />}
          text={
            <>
              <Body fontFamily="semibold">{step.subtitle}: </Body>
              <Body>{step.text}</Body>
            </>
          }
          fullBleed
        />
      ),
    };
  });

  return (
    <ActionSheetV2
      title="How auto refill works"
      illustrationSrc={getImage('autoRefill')}
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.autoRefill}
      analyticsName="auto refill info"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>
          Auto refill makes your life easier by automatically sending your medication when you need it—one less thing
          for you to remember!
        </Body>
        <SmSpacing />
        <ListBase items={autoRefillSteps} />
      </LgPadding>
    </ActionSheetV2>
  );
};
